import React from 'react';


// Components

import Bread from '../components/Bread';
import ContactComponent from '../components/Contact';

const Contact = () => {
  return (<>

      <Bread title="Contact Us" des="We are team of talanted designers making Web and Native Apps" />
      <ContactComponent/>

  </>);
}

export default Contact;
